import '../../assets/css/container/main/MainWrapper.css';
import {useNavigate, useLocation} from 'react-router-dom';
import {useAuth} from "../../global/AuthContext";
import RecentFact from "../../component/factList/RecentFact";
import SearchBar from "../../component/SearchBar";
import {useState, useEffect} from 'react';
import CategoryNavigation from "../../component/CategoryNavigation";
import {categoryLabel} from "../../global/categories";

const MainWrapper = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const {user} = useAuth();
	const isLoggedIn = !!user;

	/** 카테고리 상태 */
	const [selectedCategory, setSelectedCategory] =
		useState<string | null>(null);

	/** 검색 상태 */
	const [keyword, setKeyword] = useState("");
	const [searchType, setSearchType] =
		useState<"recent" | "my" | "interest">("recent");

	useEffect(() => {
		const nextType = location.state?.initialType;

		if (nextType && nextType !== searchType) {
			setSearchType(nextType);

			// 🔥 타입 바뀌면 기존 검색 조건 정리 (중요)
			setKeyword("");
			setSelectedCategory(null);
		}
	}, [location.state]);


	/* 🔐 searchType 변경 핸들러 (⭐ 핵심) */
	const handleSearchTypeChange = (
		nextType: "recent" | "my" | "interest"
	) => {
		const loggedIn = isLoggedIn;

		if ((nextType === "my" || nextType === "interest") && !loggedIn) {
			alert("로그인이 필요한 기능입니다.");
			navigate("/login"); // 또는 "/login"
			return;
		}

		setSearchType(nextType);
	};

	return (
		<div className="MainWrapper">
			<CategoryNavigation key={searchType} value={selectedCategory} onChange={setSelectedCategory} />


			<SearchBar
				value={keyword}
				onChange={(e) => setKeyword(e.target.value)}
				onSubmit={({keyword, type, category}) => {
					setKeyword(keyword);
					handleSearchTypeChange(type);
					setSelectedCategory(category);
				}}
				placeholder={
					selectedCategory
						? `${categoryLabel(selectedCategory)} 검색`
						: "Fact 검색"
				}
				type={searchType}
				onTypeChange={(e) =>
					handleSearchTypeChange(
						e.target.value as "recent" | "my" | "interest"
					)
				}
				category={selectedCategory}
			/>

			<div className="main-content-grid">
				<section className="recent-posts-section">

					<RecentFact
						keyword={keyword}
						type={searchType}
						category={selectedCategory}
					/>
				</section>

				<aside className="sidebar-info">
					<div className="sidebar-box">
						<h3>FactWeb</h3>
						<p className="sidebar-desc">
							사실을 검증하고<br/>
							근거로 토론하는 공간
						</p>
						<button
							className="sidebar-btn"
							onClick={() => navigate("/about")}
						>
							FactWeb 소개
						</button>
					</div>

					<div className="sidebar-box">
						<h3>공지사항</h3>
						<p className="sidebar-desc">
							업데이트 및<br/>
							운영 공지 확인
						</p>
						<button
							className="sidebar-btn"
							onClick={() => {
								if (!isLoggedIn) {
									alert("로그인이 필요한 기능입니다.");
									navigate("/login", {
										state: {redirectTo: "/notices"}
									});
									return;
								}
								navigate("/notices");
							}}
						>
							공지 보러가기
						</button>
					</div>

					<div className="sidebar-box muted">
						<p className="sidebar-hint">
							팩트에 투표하고<br/>
							긍·부정 근거를<br/>
							남겨보세요.
						</p>
					</div>
				</aside>

			</div>

		</div>
	);
};

export default MainWrapper;
